export default "__VITE_ASSET__Cx5s4cy7__"